import { render, staticRenderFns } from "./add-formation-model.vue?vue&type=template&id=74b50390&"
import script from "./add-formation-model.vue?vue&type=script&lang=js&"
export * from "./add-formation-model.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports